import { AccountResponse } from '../../models/account/AccountResponse';

/**
 * Dostęp do zakładki „Prompt Analyst” — te same warunki co `PromptAnalysisController` na backendzie:
 * addon ZALOGOWANEGO konta (każdy przegląd zużywa jego pulę), także na trialu; wyłączone konto nie ma
 * funkcji wcale. Bez wyjątku dla superadmina — zakładkę widzą tylko konta z addonem.
 */
export const promptAnalystAccess = (account: Pick<AccountResponse, 'addons' | 'accountStatus'>): { canAccess: boolean } => ({
  canAccess:
    account.addons.includes('PROMPT_ANALYST') && account.accountStatus !== 'DISABLED',
});
